/**
 * Method to check if all externally paid fields are present
 * @param values
 * @return {boolean}
 */
export const hasAllExternallyPaidFields = (values) => {
  const fields = ['dateExternallyPaid', 'externallyPaidMethod', 'externallyPaidReference'];
  return fields.every((field) => !!values[field]);
};
